var map = {
	"./Exit.png": 2976,
	"./csc207.png": 7634,
	"./csc316.png": 4513,
	"./github-black.png": 2075,
	"./github.png": 9449,
	"./linkedin.png": 2098,
	"./medium.png": 3917,
	"./nav.png": 6105,
	"./old/github-old.png": 5815,
	"./old/linkedin-old.png": 8372,
	"./old/profile-pic-old.png": 2996,
	"./profile-pic.png": 594,
	"./share.png": 1463,
	"./sta304.png": 9425,
	"./website.png": 8673,
	"./youtube.png": 4149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;